import {
    CheckCircleOutlined,
    EditOutlined,
    StopOutlined,
  } from "@ant-design/icons";
  import { PageHeader, Popconfirm, message, Tooltip } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { TableItem, ButtonItem, SegmentedItem } from "../../../Components/Items";
  
  class InsumosCompuestos extends Component {
    state = {
      idEditarInsumoCompuesto: null,
      todasInsumosCompuestos: [],
      loading: false,
      valor: 1,
    };
    componentDidMount() {
      this.consultarInsumosCompuestos(this.state.valor);
    }
    consultarInsumosCompuestos(valor) {
      this.setState({loading: true})
      axios
        .post(
          "insumoscompuestos/selectTodosInsumosCompuestos",
          { empresaId: this.props.empresaId, valor: valor },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({loading: false})
          if (res.data.status === 404) {
            this.setState({ todasInsumosCompuestos: [] });
          } else {
            this.setState({
              todasInsumosCompuestos: res.data
            });
          }
        });
    }
    deshabilitarInsumoCompuesto(value) {
      axios
        .post(
          "insumos/deshabilitarInsumo",
          { insumoId: value, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Insumo Compuesto deshabilitado");
          } else {
            message.error("Sucedio un eror y no se pudo deshabilitar");
          }
          this.consultarInsumosCompuestos(this.state.valor);
        });
    }
    habilitarInsumoCompuesto(value) {
      axios
        .post(
          "insumos/habilitarInsumo",
          { insumoId: value, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Insumo Compuesto habilitado");
          } else {
            message.error("Sucedio un eror y no se pudo habilitar");
          }
          this.consultarInsumosCompuestos(this.state.valor);
        });
    }
    agregarInsumoCompuesto() {
      this.props.history.push("/panel/agregarInsumoCompuesto");
    }
    editarInsumoCompuesto(id) {
      this.props.history.push("/panel/editarInsumoCompuesto", { id });
    }
    abrirAgregarFamilia() {
      this.setState({ modalAgregarFamilia: true });
    }
    cerrarAgregarFamilia() {
      this.setState({ modalAgregarFamilia: false });
      this.consultarInsumosCompuestos(this.state.valor);
    }
    render() {
      const columns = [
        /*{
          title: "Codigo",
          dataIndex: "codigo",
          key: "codigo",
          defaultSortOrder: 'ascend',
          sorter: (a, b) => {
            if (a.codigo < b.codigo) {
              return -1;
            }
            if (a.codigo > b.codigo) {
              return 1;
            }
            return 0;
          },
          buscar: "codigo",
          width: "10%",
        },*/
        {
          title: "Clave",
          dataIndex: "clave",
          key: "clave",
          sorter: (a, b) => {
            if (Number(a.clave) < Number(b.clave)) {
              return -1;
            }
            if (Number(a.clave) > Number(b.clave)) {
              return 1;
            }
            return 0;
          },
          buscar: "clave",
          width: "10%",
        },
        {
          title: "Descripción",
          dataIndex: "descripcion",
          key: "descripcion",
          sorter: (a, b) => {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          },
          buscar: "descripcion",
          width: "36%",
        },
        {
          title: "Costo",
          dataIndex: "costo",
          key: "costo",
          sorter: (a, b) => {
            if (a.costo < b.costo) {
              return -1;
            }
            if (a.costo > b.costo) {
              return 1;
            }
            return 0;
          },
          render: (value) => "$ " + value.toFixed(2),
          width: "6%",
        },
        {
          title: "Unidad",
          dataIndex: "unidad",
          key: "unidad",
          sorter: (a, b) => {
            if (a.unidad < b.unidad) {
              return -1;
            }
            if (a.unidad > b.unidad) {
              return 1;
            }
            return 0;
          },
           width: "10%",
        },
        {
          title: "Familia",
          dataIndex: "familia",
          key: "familia",
          sorter: (a, b) => {
            if (a.familia < b.familia) {
              return -1;
            }
            if (a.familia > b.familia) {
              return 1;
            }
            return 0;
          },
          width: "18%",
        },
        {
          title: "Acción",
          dataIndex: "accion",
          key: "accion",
          align: "center",
          width: "12%",
          onHeaderCell: () => ({
            style: { textAlign: 'center', padding: '4px' }
          }),
          onCell: () => ({
            className: "acciones-sin-hover",
            style: { textAlign: 'center', padding: '4px' }
          }),
          render: (value, index) => {
            let buttons = [];

            // Botón Editar
            if (this.props.permisoEditarInsumoCompuesto) {
              buttons.push(
                <Tooltip title="Editar Insumo Compuesto" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`editar-${index}`}
                    type="default"
                    size="small"
                    cyan
                    icon={<EditOutlined />}
                    onClick={() => this.editarInsumoCompuesto(value._id)}
                  >
                  </ButtonItem>
                </Tooltip>
              );
            }

            // Botón Habilitar/Deshabilitar
            if (this.props.permisoDeshabilitarInsumoCompuesto) {
              if (value.estado === 1) {
                buttons.push(
                  <Popconfirm
                    key={`deshabilitar-${index}`}
                    title="Seguro que quieres deshabilitar este insumo compuesto"
                    onConfirm={() => this.deshabilitarInsumoCompuesto(value._id)}
                    okText="Si"
                    cancelText="No"
                  >
                    <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                      <ButtonItem
                        type="default"
                        size="small"
                        lima
                        icon={<CheckCircleOutlined />}
                      >
                      </ButtonItem>
                    </Tooltip>
                  </Popconfirm>
                );
              } else {
                buttons.push(
                  <Popconfirm
                    key={`habilitar-${index}`}
                    title="Seguro que quieres habilitar este insumo compuesto"
                    onConfirm={() => this.habilitarInsumoCompuesto(value._id)}
                    okText="Si"
                    cancelText="No"
                  >
                    <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                      <ButtonItem
                        type="default"
                        size="small"
                        rojo
                        icon={<StopOutlined />}
                      >
                      </ButtonItem>
                    </Tooltip>
                  </Popconfirm>
                );
              }
            }

            return <div className="acciones-container">{buttons}</div>;
          },
        },
      ];
      return (
        <>
          <PageHeader
            title="Insumos Compuestos"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                options={[{label: 'Activo', value: 1}, {label: 'Deshabilitado', value: 2}, {label: 'Todos', value: 3}]}
                onChange={(value) => {
                  this.consultarInsumosCompuestos(value)
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
            }
                {this.props.permisoAgregarInsumoCompuesto &&
                <ButtonItem
                  type="primary"
                  key="agregarInsumoCompuesto"
                  olivo
                  onClick={this.agregarInsumoCompuesto.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Insumo Compuesto
                </ButtonItem>}
              </>
            }
          />
          <TableItem
          loading={this.state.loading}
            size="small"
            dataSource={this.state.todasInsumosCompuestos}
            columns={columns}
            pagination={false}
            onRow={(record) => ({
              onDoubleClick: () => this.editarInsumoCompuesto(record._id),
            })}
          />
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      permisoAgregarInsumoCompuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d8d84b2da7c85c1a8d0b")?.activado,
      permisoEditarInsumoCompuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d66d4b2da7c85c1a8d06")?.activado,
      permisoDeshabilitarInsumoCompuesto: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6472d69a4b2da7c85c1a8d07")?.activado,
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };
  
  export default connect(mapStateToProps)(InsumosCompuestos);
  